import React, { useState, useEffect } from 'react'
import { Box } from 'rebass/styled-components'
import { prepareFeed } from '../../helpers/FeedHandler'
import Spacer from '../general/Spacer'
import Filter from '../forms/Filter'
import NoResults from '../content/NoResults'

const Grid = ({ options, data, renderUpdate, pageData, initialFeed }) => {
    const primaryFeed = prepareFeed(initialFeed, options, pageData)
    const [view, setView] = useState(primaryFeed)
    const [updatedFeed, setUpdatedFeed] = useState(false)

    useEffect(() => {
        if (data) {
            setUpdatedFeed(prepareFeed(data, options))
        }
    }, [data])
    useEffect(() => {
        if (updatedFeed) {
            setView(updatedFeed)
        }
    }, [updatedFeed])

    return (
        <Spacer spacing={options.spacing}>
            {options.showFilter && <Filter onChange={renderUpdate} />}
            {view ? (
                <Box
                    variant='container'
                    py='md'
                    sx={{
                        display: 'grid',
                        gridGap: 'md',
                        gridTemplateColumns: [
                            '1fr',
                            '1fr',
                            '1fr',
                            'repeat(2, 1fr)',
                            'repeat(3, 1fr)',
                        ],
                    }}
                >
                    {view}
                </Box>
            ) : (
                <NoResults />
            )}
        </Spacer>
    )
}

export default Grid
